<template>
    <div class="vrm-circular-progress">
        <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`">
            <circle
                class="vrm-circular-progress-background"
                :cx="size / 2"
                :cy="size / 2"
                :r="radius"
                :stroke-width="`${strokeWidth}px`"
            />
            <circle
                class="vrm-circular-progress-progress"
                :cx="size / 2"
                :cy="size / 2"
                :r="radius"
                :stroke-width="`${strokeWidth}px`"
                :transform="`rotate(-90 ${size / 2} ${size / 2})`"
                :style="{ strokeDasharray: dashArray, strokeDashoffset: dashOffset }"
            />
        </svg>
        <div class="vrm-circular-progress-inside">
            <slot />
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component({
    components: {},
})
@AngularDirective('vrm-circular-progress')
export default class VrmCircularProgress extends Vue {
    @Prop({ required: true })
    progress;

    text = '28 days';
    strokeWidth = 10;
    size = 200;
    get radius() {
        return (this.size - this.strokeWidth) / 2;
    }
    get dashArray() {
        return this.radius * Math.PI * 2;
    }
    get dashOffset() {
        return this.dashArray - (this.dashArray * this.progress) / 100;
    }
}
</script>
